import Api from '.';
import { endpoints } from './endpoints';

export default class LoginApi extends Api {

    generateOtp(data) {
        console.log("In generateOtp", data)
        let url = this.buildUrl(endpoints.login.generateOtp)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

    verifyOtp(data) {
        let url = this.buildUrl(endpoints.login.verifyOtp)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

    logout() {
        let url = this.buildUrl(endpoints.login.logout)
        return this.fetch(url, "POST").then(response => response);
    }
    common(data) {
        let url = this.buildUrl(endpoints.login.common, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    
    encrypt(data) {
        return this.encrypt(data);
    }
    encryptSSO(data) {
        return this.encryptSSO(data);
    }

    setmpin(data) {
        let url = this.buildUrl(endpoints.login.SETMPIN)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    getUsetInfo() {
        let url = this.buildUrl(endpoints.login.getUserInfo)
        return this.fetch(url, "GET").then(response => response);
    }

    GetOtpPreference() {
        let url = this.buildUrl(endpoints.login.GetOtpPreference, "full")
        console.log("GetOtpPreference URL:", url);  
        return this.fetch(url, "GET").then(response => response);
    }

    Bitaly_Link(data) {
        let url = this.buildUrl(endpoints.reports.bitlyLink)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    getAllFunds(data) {
        let url = this.buildUrl(endpoints.preLogin.getAllFunds, "full");
        return this.fetch(url, "POST", JSON.stringify(data)).then(
            (response) => response
        );
    }

    getFundsCategorisation(data) {
        let url = this.buildUrl(endpoints.preLogin.getFundsCategorisation, "full");
        return this.fetch(url, "POST", JSON.stringify(data)).then(
            (response) => response
        );
    }

    getFundsCategorisation2(data) {
        let url = this.buildUrl(endpoints.preLogin.getFundsCategorisation2, "full");
        return this.fetch(url, "GET",).then(
            (response) => response
        );
    }


    GetPortfolioDataSchemeWise(data) {
        let url = this.buildUrl(endpoints.preLogin.GetPortfolioDataSchemeWise, "full");
        return this.fetch(url, "POST", JSON.stringify(data)).then(
            (response) => response
        );
    }

    removeCookie(data) {
        let url = this.buildUrl(endpoints.logout.removeCookie);
        return this.fetch(url, "POST", JSON.stringify(data)).then(
            (response) => response
        );
    }

    GetGatewayData(data) {
        let url = this.buildUrl(endpoints.login.GetGatewayData, "full");
        return this.fetch(url, "POST", JSON.stringify(data)).then(
            (response) => response
        );
    }

    GetTransactionSummaryDB(data) {
        let url = this.buildUrl(endpoints.login.GetTransactionSummaryDB, "full");
        return this.fetch(url, "POST", JSON.stringify(data)).then(
            (response) => response
        );
    }
    
    GetUPIEmandateCount(data) {
        let url = this.buildUrl(endpoints.login.GetUPIEmandateCount, "full");
        return this.fetch(url, "POST", JSON.stringify(data)).then(
            (response) => response
        );
    }

    initiateToken(data) {
        let url = this.buildUrl(endpoints.login.initiateToken);
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

}